import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

const useQueryAutomobileDetail = (id?: string | number) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ["CarDetails", id],
    queryFn: () => fetchApi(`project?q=${id}`, token).get(),
    refetchOnWindowFocus: false,
  });
};

export default useQueryAutomobileDetail;
